import { useLocation, Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { login } from "../auth/msal";

export function LoginPage() {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (isAuthenticated) {
    const from = (location.state as { from?: Location } | null)?.from?.pathname ?? "/";
    return <Navigate to={from} replace />;
  }

  const reason = new URLSearchParams(location.search).get("reason");

  const messages: Record<string, string> = {
    session_expired: "La tua sessione è scaduta. Effettua di nuovo l'accesso per continuare.",
    logged_out: "Hai effettuato il logout. Ti aspettiamo al prossimo accesso.",
  };
  const subline = reason && messages[reason]
    ? messages[reason]
    : "Accedi con il tuo account aziendale per amministrare i consensi AutoConnexa.";

  return (
    <div className="centered">
      <div className="login-card">
        <div className="login-card__mark" aria-hidden="true" />
        <h1>Benvenuto</h1>
        <p>{subline}</p>
        <button
          type="button"
          className="btn btn--block"
          onClick={() => void login("/")}
        >
          Accedi con SSO
        </button>
        <p style={{ marginTop: 16, fontSize: 12, color: "var(--color-mute)" }}>
          Sarai reindirizzato al provider di identità AutoConnexa.
        </p>
      </div>
    </div>
  );
}
